var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIdelBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25083 12.66C8.2644 12.7735 8.25186 12.8885 8.21416 12.9964C8.17647 13.1043 8.11462 13.2022 8.03333 13.2825C7.89281 13.4222 7.70272 13.5006 7.50458 13.5006C7.30644 13.5006 7.11635 13.4222 6.97583 13.2825L3.97583 10.2825C3.89213 10.2021 3.82824 10.1033 3.7892 9.99398C3.75015 9.88465 3.73702 9.76776 3.75083 9.6525V5.8125L0.158331 1.215C0.036537 1.05865 -0.0184189 0.860444 0.00547166 0.663697C0.0293623 0.466951 0.130157 0.28766 0.285831 0.165C0.417785 0.0591296 0.581658 0.000981303 0.750831 0H11.2508C11.42 0.000981303 11.5839 0.0591296 11.7158 0.165C11.8715 0.28766 11.9723 0.466951 11.9962 0.663697C12.0201 0.860444 11.9651 1.05865 11.8433 1.215L8.25083 5.8125V12.66ZM2.25083 1.5L5.25083 5.295V9.435L6.75083 10.935V5.2875L9.75083 1.5M9.00083 10.5L12.7508 14.25L16.5008 10.5H9.00083Z",
    fill: "#39ACE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIdelBlue);
export default __webpack_public_path__ + "static/media/filter_idel_blue.0de3d0402fb661b6e1c6176da33aa16f.svg";
export { ForwardRef as ReactComponent };